import React, { useState } from "react";
import { Handle, Position } from "reactflow";
import { TextField } from "@mui/material";

const CustomNode = ({ data, id }) => {
  const [label, setLabel] = useState(data.label);
  const [isEditing, setIsEditing] = useState(false);

  const handleBlur = () => {
    setIsEditing(false);
    data.onUpdate(id, label);
  };

  return (
    <div style={{ padding: 10, background: "#fff", borderRadius: 6, border: "1px solid #ddd" }}>
      <Handle type="target" position={Position.Left} />
      {isEditing ? (
        <TextField
          value={label}
          onChange={(e) => setLabel(e.target.value)}
          onBlur={handleBlur}
          autoFocus
          fullWidth
          size="small"
        />
      ) : (
        <div onDoubleClick={() => setIsEditing(true)}>{label}</div>
      )}
      <Handle type="source" position={Position.Right} />
    </div>
  );
};

export default CustomNode;
